<template>
  <div class="mb-5">
    <h5 class="mb-3" v-if="!routeIsArborescenceGraph">Évaluation</h5>
    <div>
      <b-table-simple borderless :class="{ 'w-table': isStudent }">
        <b-tbody>
          <b-tr v-if="routeIsArborescenceGraph">
            <b-td colspan="2"
              ><h6 class=" font-weight-bold">Participation globale</h6></b-td
            >
            <b-td>
              <div class="text-center">
                <b-button
                  variant="link"
                  class="float-right mr-2 px-1"
                  v-b-modal.modal-1
                >
                  <b-icon
                    font-scale="1.1"
                    icon="info-circle-fill"
                    variant="primary"
                  ></b-icon>
                </b-button>
              </div>
            </b-td>
          </b-tr>
          <b-tr>
            <b-td>Clarté</b-td>
            <template v-if="isTeacher">
              <b-td class="text-lightgrey"
                >{{ getClarity.avg | removeDecimals }}%
              </b-td>
              <b-td
                ><b-input-group :append="isTeacher ? '%' : null">
                  <b-form-input
                    class="grid-input"
                    @change="
                      onChange({
                        points: $event,
                        concept: getClarity.concept,
                        valid: 1
                      })
                    "
                    v-model="getClarity.avgTeacher"
                    :state="valid[1].status"
                  ></b-form-input>
                </b-input-group>
              </b-td>
            </template>
            <td v-else>
              {{ getClarity.avgTeacher ? getClarity.avgTeacher : "----" }}
            </td>
          </b-tr>
          <b-tr>
            <b-td>Cohérence</b-td>
            <template v-if="isTeacher">
              <b-td class="text-lightgrey w-colum"
                >{{ getConsistency.avg | removeDecimals }}%
              </b-td>
              <b-td
                ><b-input-group :append="isTeacher ? '%' : null">
                  <b-form-input
                    class="grid-input"
                    @change="
                      onChange({
                        points: $event,
                        concept: getConsistency.concept,
                        valid: 2
                      })
                    "
                    v-model="getConsistency.avgTeacher"
                    :state="valid[2].status"
                  ></b-form-input>
                </b-input-group>
              </b-td>
            </template>
            <td v-else>
              {{
                getConsistency.avgTeacher ? getConsistency.avgTeacher : "----"
              }}
            </td>
          </b-tr>
          <b-tr>
            <b-td>Pertinence</b-td>
            <template v-if="isTeacher">
              <b-td class="text-lightgrey"
                >{{ getRelevance.avg | removeDecimals }}%
              </b-td>
              <b-td
                ><b-input-group :append="isTeacher ? '%' : null">
                  <b-form-input
                    class="grid-input"
                    @change="
                      onChange({
                        points: $event,
                        concept: getRelevance.concept,
                        valid: 3
                      })
                    "
                    v-model="getRelevance.avgTeacher"
                    :state="valid[3].status"
                  ></b-form-input>
                </b-input-group>
              </b-td>
            </template>
            <td v-else>
              {{ getRelevance.avgTeacher ? getRelevance.avgTeacher : "----" }}
            </td>
          </b-tr>
          <b-tr>
            <b-td>Richesse</b-td>
            <template v-if="isTeacher">
              <b-td class="text-lightgrey"
                >{{ getSufficiency.avg | removeDecimals }}%
              </b-td>
              <b-td>
                <b-input-group :append="isTeacher ? '%' : null">
                  <b-form-input
                    class="grid-input"
                    @change="
                      onChange({
                        points: $event,
                        concept: getSufficiency.concept,
                        valid: 4
                      })
                    "
                    v-model="getSufficiency.avgTeacher"
                    :state="valid[4].status"
                  ></b-form-input>
                </b-input-group>
              </b-td>
            </template>
            <td v-else>
              {{
                getSufficiency.avgTeacher ? getSufficiency.avgTeacher : "----"
              }}
            </td>
          </b-tr>
          <b-tr>
            <b-td>Recherche de sources</b-td>
            <template v-if="isTeacher">
              <b-td class="text-lightgrey"
                >{{ getRechercheSource.avg | removeDecimals }}%
              </b-td>
              <b-td>
                <b-input-group :append="isTeacher ? '%' : null">
                  <b-form-input
                    class="grid-input"
                    @change="
                      onChange({
                        points: $event,
                        concept: getRechercheSource.concept,
                        valid: 5
                      })
                    "
                    v-model="getRechercheSource.avgTeacher"
                    :state="valid[5].status"
                  ></b-form-input>
                </b-input-group>
              </b-td>
            </template>
            <td v-else>
              {{
                getRechercheSource.avgTeacher
                  ? getRechercheSource.avgTeacher
                  : "----"
              }}
            </td>
          </b-tr>
          <b-tr v-if="routeIsArborescenceGraph">
            <b-td colspan="2" class="pt-3">
              Évaluation totale
            </b-td>
            <b-td class="pl-4 pt-3">
              {{ totalAveragePoints | removeDecimals }}%
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>
    <div>
      <b-modal id="modal-1" title="Informations sur l'évaluation" size="lg">
        <b-container>
          <p class="my-4">
            En ajoutant une rétroaction sur un message, le système calcule
            automatiquement une note. Pour voir ou modifier l'attribution de
            points, consultez l'onglet <u>"Mes rétroactions"</u> depuis votre
            page page d'accueil.
          </p>
          <p>
            Vous pouvez aussi faire une évaluation sur la participation globale
            d'un étudiant.
          </p>
          <p>
            Vous restez maître de votre évaluation. Utiliser les cases vides
            pour donner votre note finale de chaque critère.
          </p>
        </b-container>
        <template v-slot:modal-footer="{ cancel }">
          <div class="w-100">
            <b-button
              variant="primary"
              pill
              class="float-right"
              @click="cancel()"
            >
              Compris!
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
/**
 * @file       Student correction component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { adminStudentMixin } from "@/modules/admin/components/students/mixins";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "studentProfileCorrection",

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      valid: {
        1: { concept: "Clarté", status: null },
        2: { concept: "Cohérence", status: null },
        3: { concept: "Pertinence", status: null },
        4: { concept: "Richesse", status: null },
        5: { concept: "Recherche de sources", status: null }
      }
    };
  },
  mixins: [adminStudentMixin],
  props: {
    deliberation: Number,
    groupId: Number
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    /**
     * Total average points.
     * 
     * @return  {Decimal}    The total average points
     */
    totalAveragePoints: function() {
      return (this.getClarity.avgTeacher
        + this.getConsistency.avgTeacher
        + this.getRelevance.avgTeacher
        + this.getSufficiency.avgTeacher
        + this.getRechercheSource.avgTeacher) / 5;
    },

    /**
     * Get evaluation.
     * 
     * @return  {Object}    The evaluation
     */
    getEvaluation() {
      return this.totalGrades
        .find(tg => tg.group == parseInt(this.groupId))
        .deliberations.find(c => c.deliberation == this.deliberation);
    },

    /**
     * Get clarity.
     * 
     * @return  {Object}    The clarity
     */
    getClarity: function() {
      var clarity = {};
      clarity.teacher = this.getEvaluation.deliberation_grade_concepts.find(
        c => c.evaluation_concept.concept == "Clarté"
      );
      clarity.system = this.getEvaluation.deliberation_concepts.find(
        c => c.evaluation_concept.concept == "Clarté"
      );
      return {
        avg: clarity.system ? clarity.system.averagePoints : "",
        concept: clarity.system ? clarity.system.evaluation_concept.id : 1,
        avgTeacher: clarity.teacher ? clarity.teacher.points : ""
      };
    },

    /**
     * Get consistency.
     * 
     * @return  {Object}    The consistency
     */
    getConsistency: function() {
      var consistency = {};
      consistency.teacher = this.getEvaluation.deliberation_grade_concepts.find(
        c => c.evaluation_concept.concept == "Cohérence"
      );
      consistency.system = this.getEvaluation.deliberation_concepts.find(
        c => c.evaluation_concept.concept == "Cohérence"
      );
      return {
        avg: consistency.system ? consistency.system.averagePoints : "",
        concept: consistency.system
          ? consistency.system.evaluation_concept.id
          : 2,
        avgTeacher: consistency.teacher ? consistency.teacher.points : ""
      };
    },

    /**
     * Get relevance.
     * 
     * @return  {Object}    The relevance
     */
    getRelevance: function() {
      var relevance = {};
      relevance.teacher = this.getEvaluation.deliberation_grade_concepts.find(
        c => c.evaluation_concept.concept == "Pertinence"
      );
      relevance.system = this.getEvaluation.deliberation_concepts.find(
        c => c.evaluation_concept.concept == "Pertinence"
      );
      return {
        avg: relevance.system ? relevance.system.averagePoints : "",
        concept: relevance.system ? relevance.system.evaluation_concept.id : 3,
        avgTeacher: relevance.teacher ? relevance.teacher.points : ""
      };
    },

    /**
     * Get sufficiency.
     * 
     * @return  {Object}    The sufficiency
     */
    getSufficiency: function() {
      var sufficiency = {};
      sufficiency.teacher = this.getEvaluation.deliberation_grade_concepts.find(
        c => c.evaluation_concept.concept == "Richesse"
      );
      sufficiency.system = this.getEvaluation.deliberation_concepts.find(
        c => c.evaluation_concept.concept == "Richesse"
      );
      return {
        avg: sufficiency.system ? sufficiency.system.averagePoints : "",
        concept: sufficiency.system
          ? sufficiency.system.evaluation_concept.id
          : 4,
        avgTeacher: sufficiency.teacher ? sufficiency.teacher.points : ""
      };
    },

    /**
     * Get recherche source.
     * 
     * @return  {Object}    The recherche source
     */
    getRechercheSource: function() {
      var rechercheSource = {};
      rechercheSource.teacher = this.getEvaluation.deliberation_grade_concepts.find(
        c => c.evaluation_concept.concept == "Recherche de sources"
      );
      rechercheSource.system = this.getEvaluation.deliberation_concepts.find(
        c => c.evaluation_concept.concept == "Recherche de sources"
      );
      return {
        avg: rechercheSource.system ? rechercheSource.system.averagePoints : "",
        concept: rechercheSource.system
          ? rechercheSource.system.evaluation_concept.id
          : 5,
        avgTeacher: rechercheSource.teacher
          ? rechercheSource.teacher.points
          : ""
      };
    },

    /**
     * Check if current user is a teacher.
     *
     * @return     {bool}  true or false.
     */
    isTeacher() {
      return this.profile.role == "teacher" ? true : false;
    },

    /**
     * Check if current user is a student.
     *
     * @return     {bool}  true or false.
     */
    isStudent() {
      return this.profile.role == "student" ? true : false;
    }
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Change event.
     * 
     * @param  {Object}    The event
     */
    onChange(event) {
      this.valid[event.valid].status = true;
      var update = {
        ...event,
        user: this.user.id,
        deliberation: this.deliberation
      };
      this.$store
        .dispatch("admin/postGradeDeliberation", update)
        .then(() => {
          this.valid[event.valid].status = null;
          this.$root.$bvToast.toast("Mise à jour effectuée avec succès.", {
            title: "Succès"
          });
        })
        .catch(() => {
          this.valid[event.valid].status = false;
          this.$root.$bvToast.toast("La mise à jour à échouée", {
            title: "Erreur",
            variant: "danger"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.was-validated .form-control:invalid,
.form-control.is-invalid {
  border-color: #ced4da !important;
  box-shadow: none !important;
}

.table > tbody > tr {
  > td {
    vertical-align: middle;
  }
  .w-colum {
    min-width: 50px !important;
  }
}

.w-table {
  width: 320px !important;
}

.text-lightgrey {
  color: #bbbbbb;
}
</style>
